import React from 'react';
import { Drawer } from 'antd';
import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import { onMobileNavToggle } from 'redux/actions/Theme';
import Logo from './Logo';
import Flex from 'components/shared-components/Flex';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ReduxState } from '../../redux/reducers';

interface MobileNavProps {
  mobileNav: boolean;
  onMobileNavToggle: (mobileNav: boolean) => void;
  menuContent: React.ReactNode;
}

export const MobileNav = ({ mobileNav, onMobileNavToggle, menuContent }: MobileNavProps) => {
  const onClose = () => {
    onMobileNavToggle(false);
  };

  return (
    <Drawer
      placement="left"
      closable={false}
      onClose={onClose}
      visible={mobileNav}
      bodyStyle={{ padding: 4 }}
      contentWrapperStyle={{ transition: 'none' }}
      maskStyle={{ transition: 'none', animation: 'none' }}
    >
      <Flex flexDirection="column" className="h-100">
        <Flex justifyContent="between" alignItems="center">
          <Logo mobileLogo={true} />
          <div className="nav-close" onClick={() => onClose()}>
            <ArrowLeftOutlined />
          </div>
        </Flex>
        <div className="mobile-nav-menu">
          <Scrollbars autoHide>{menuContent}</Scrollbars>
        </div>
      </Flex>
    </Drawer>
  );
};

const mapStateToProps = ({ theme }: ReduxState) => {
  const { mobileNav } = theme;
  return { mobileNav };
};

export default connect(mapStateToProps, { onMobileNavToggle })(MobileNav);
